<!-- src/components/CookieConsent/CookiePolicyDialog.vue -->
<template>
  <el-dialog
    :visible.sync="visibleSync"
    :title="$t(title)"
    width="70%"
    :before-close="handleClose"
    append-to-body
    class="policy-dialog"
  >
    <div class="policy-content" v-html="sanitizedContent"></div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleClose">{{ $t('button.close') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import DOMPurify from 'dompurify'
export default {
  name: 'policyDialog',
  
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  
  computed: {
    sanitizedContent() {
      if (!this.content) return ''
      return DOMPurify.sanitize(this.content)
    },
    
    visibleSync: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
    }
  }
};
</script>

<style scoped>
.policy-dialog ::v-deep .el-dialog__body {
  max-height: 600px;
  overflow-y: auto;
  padding: 20px;
}

.policy-content {
  line-height: 1.6;
  color: #333;
}

/* 富文本样式 */
.policy-content ::v-deep h1 {
  font-size: 24px;
  margin-bottom: 20px;
}

.policy-content ::v-deep h2 {
  font-size: 20px;
  margin: 20px 0 10px;
}

.policy-content ::v-deep p {
  margin-bottom: 15px;
}

.policy-content ::v-deep ul,
.policy-content ::v-deep ol {
  margin-bottom: 15px;
  padding-left: 20px;
}

/* 为包含表格的容器添加 */
.policy-content ::v-deep table,
.policy-content ::v-deep th,
.policy-content ::v-deep td {
  border: 1px solid #ccc; /* 设置边框颜色和样式 */
  border-collapse: collapse; /* 合并边框，使表格看起来更整洁 */
  padding: 8px; /* 可选：给单元格内容添加一些内边距，使其不那么拥挤 */
}

/* 可选：为表头添加背景色，使其更醒目 */
.policy-content ::v-deep th {
  background-color: #f9f9f9;
}

@media (max-width: 768px) {
  ::v-deep .el-dialog {
    width: 95%;
  }
}
</style>